import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable, combineLatest } from 'rxjs';
import { Workspace } from '../../../shared/models/workspace';
import { getAdminWorkspace, getPortfolioUser } from '../../admin-store/admin.selectors';
import { LoadWorkspaceRolesAction } from '../../../workspace/workspace-store';
import {
  ClearAdminPortfolioAction,
  LoadAdminPortfolioAction,
  LoadPortfolioUserByIdAction,
  UpdateAdminWorkspaceUserAction
} from '../../admin-store';
import { SubSink } from 'subsink';
import { ActivatedRoute, Params, Router, NavigationExtras } from '@angular/router';
import { DateHelper, WorkspaceUser } from 'app/internal/shared';
import { getRolesForRoleDropdown } from 'app/internal/workspace/workspace-store/workspace.selectors';
import { Role } from 'app/internal/workspace/shared/models';
import { UserProfile } from 'app/internal/user/models/user-profile';
import { getUserProfile } from 'app/internal/user/redux/user.selectors';

@Component({
  templateUrl: './admin-portfolio-edit-user.component.html',
  styleUrls: ['./admin-portfolio-edit-user.component.scss'],
  standalone: false
})
export class AdminPortfolioEditUserComponent implements OnInit, OnDestroy {

  workspace$: Observable<Workspace>;
  user$: Observable<WorkspaceUser>;
  roles$: Observable<Role[]>;
  userProfile$: Observable<UserProfile>;
  roles: Role[];
  workspaceId: string;
  user: WorkspaceUser;
  linkFullName: string;
  joinedOn: string;
  navigateUrl: any;
  navigationExtras: NavigationExtras;
  portfolioBreadCrumbText: string;

  private subs = new SubSink();

  constructor(
    private store: Store<AppState>,
    private router: Router, private route: ActivatedRoute) {
    this.workspace$ = this.store.pipe(select(getAdminWorkspace));
    this.user$ = this.store.pipe(select(getPortfolioUser));
    this.roles$ = this.store.pipe(select(getRolesForRoleDropdown));
    this.userProfile$ = this.store.pipe(select(getUserProfile));
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.workspaceId = params['workspaceId'];
        const userId = params['id'];
        this.store.dispatch(new LoadAdminPortfolioAction({ workspaceId: this.workspaceId, includeIntegrationDetail: false }));
        this.store.dispatch(new LoadPortfolioUserByIdAction({ userId: userId, workspaceId: this.workspaceId }));
        this.store.dispatch(new LoadWorkspaceRolesAction());
      }
    );

    this.subs.sink = combineLatest([this.user$, this.roles$]).subscribe(([user, roles]) => {
      this.user = user;
      this.roles = roles;
      if (this.user && this.roles) {
        this.linkFullName = user?.firstName + ' ' + user?.lastName;
        this.joinedOn = DateHelper.getDateString(user?.joinedOn);
      }
    });

    this.subs.sink = this.workspace$.subscribe(workspace => {
      if (workspace) {
        if (workspace.companyName && workspace.companyName !== '') {
          this.portfolioBreadCrumbText = workspace.companyName;
        } else {
          this.portfolioBreadCrumbText = workspace.name;
        }
      }
    });

    this.navigateUrl = ['/useraccount/admin/portfolios', this.workspaceId];
    const queryParams = { tabIndex: '2' };
    this.navigationExtras = { queryParams };
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.store.dispatch(new ClearAdminPortfolioAction());
  }

  onSaveUser(workspaceUser: WorkspaceUser) {
    this.store.dispatch(new UpdateAdminWorkspaceUserAction({ workSpaceUser: workspaceUser, workSpaceId: this.workspaceId }));
  }

  onCancel() {
    this.router.navigate(this.navigateUrl, this.navigationExtras);
  }
}
